<template>
  <div>
    <wc-section-title title='Lawn'></wc-section-title>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'lawn-base',
  computed: {
    menu () {
      return [
        {
          title: 'Lawn Dashboard',
          icon: 'mdi-grass',
          route: { name: 'LawnDashboard' }
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', 'Lawn Menu')
    this.$store.dispatch('loadMainMenu', this.menu)
  }
}
</script>
